import { jsx as _jsx } from "react/jsx-runtime";
import './InputClearBtn.scss';
import { TertiaryBtn } from '../btn/TertiaryBtn';
import { SvgCross } from '../../index';
export const InputClearBtn = (props) => {
    return (_jsx("div", { className: 'sg-inputClearBtn', children: _jsx(TertiaryBtn, { icon: { element: _jsx(SvgCross, {}) }, isSuppressed: true, isDanger: true, tooltip: props.tooltip, onClick: props.onClick, testId: props.testId }) }));
};
//# sourceMappingURL=InputClearBtn.js.map